import { useMutation, useQueryClient } from '@tanstack/react-query';
import { acceptFileMutationFunction } from '@/modules/FileList/queries/acceptFile/acceptFileMutationFunction.ts';
import { newFilesListQueryOptions } from '@/modules/FileList/queries/newFilesList/newFilesListQueryOptions.ts';
import { myFilesListDefaultQueryOption } from '@/modules/FileList/queries/myFilesList/myFilesListDefaultQueryOption.ts';

export default () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: acceptFileMutationFunction,
    onSuccess: () =>
      Promise.all([
        queryClient.invalidateQueries({
          queryKey: newFilesListQueryOptions({}).queryKey,
        }),
        queryClient.invalidateQueries({
          queryKey: myFilesListDefaultQueryOption({}).queryKey,
        }),
      ]),
    meta: {
      successToast: 'پرونده با موفقیت دریافت شد.',
    },
  });
};
